import { triggerDownload } from "./exportSources.js";

/**
 * Packages already-fetched blobs into a single ZIP (STORE mode — client-zip
 * does not compress) and triggers a local download. No recompression: the
 * inputs (PDF/XLSX/GLB) are already compressed.
 */
export async function buildAndDownloadZip(files, zipName) {
  const { downloadZip } = await import("client-zip");
  const entries = files.map(({ filename, blob }) => ({
    name: filename,
    input: blob,
  }));
  const zipBlob = await downloadZip(entries).blob();
  triggerDownload(zipBlob, zipName);
}
